<template>
	<div class="product-option">
		<label class="radio-container" :class="{ selected: isSelected }">
            <div class="image-container" v-if="overlay || productId === 'button-holes'">
                <img v-if="overlay" v-lazy="overlay" class="overlay" :class="{ 'overlay-with-under': overlay && item.mainImage }">
                <img v-if="item.mainImage" v-lazy="item.mainImage" :alt="item.name" :class="[{'under-overlay' : overlay}, {'thread' : productId == 'button-holes'}]">
                <div v-else class="image-substitute" :class="[{'under-overlay' : overlay}, {'thread' : productId === 'button-holes'}]"></div>
                <SelectedFabric v-if="showFabric" class="fabric-sample d-lg-none" :hideHeading="true">
                    <template v-if="item.preview">
                        <img :src="item.preview" class="preview-over" :alt="$tr.product.previewLong">
                    </template>
                </SelectedFabric>
            </div>
            <template v-else>
                <span v-if="item.batch" class="fabric-batch">{{ item.batch }}</span>
                <img v-if="item.mainImage" v-lazy="item.mainImage" :alt="item.name" :class="[{'fit-cover' : productId === 'fabrics' || productId === 'contrasts-fabrics'}]">
            </template>
            <div class="product-action">
                <input type="checkbox" class="select" :name="productId" :checked="isSelected" @change="saveOption" v-if="canSelectMultiple && item.id !== 'none'">
                <input type="radio" class="select" :name="productId" :checked="isSelected" @change="saveOption" v-else>
                <span class="checkmark"></span>
                <div>
                    <h5 class="heading">{{ item.name }}</h5>
                    <span class="price oldPrice" v-if="item.oldPrice">{{ item.oldPrice }}</span>
                    <span class="price" v-if="item.price">{{ item.price }}</span>
                </div>
                <div class="d-block d-lg-none preview-button">
                    <Button type="centered" @click="$emit('openSidebar'); saveOption()">
                        {{ $tr.product.preview }}
                    </Button>
                </div>
            </div>
		</label>
	</div>
</template>

<script>
	import Button from "../../common/Button";
	import { EventBus } from "../../../event-bus";
	import SelectedFabric from "../../common/SelectedFabric";

    export default {
		name: "ProductOption",
        components: {SelectedFabric, Button},
        props: [
			"item",
			"productId",
			"overlay",
			"showFabric",
            "multiple"
		],
		methods: {
			saveOption(e) {
			    // Simple single product option
                if (!this.canSelectMultiple)
				    this.$set(this.$db.products, this.productId, this.item);
                // 2 products can be selected
                else if (this.multiple) {
                    // Checkbox unchecked
                    if (!e.target.checked) {
                        if (this.$db.products[this.productId].id === this.item.id) {
                            if (this.$db.products[this.productId + "-1"]) {
                                this.$set(this.$db.products, this.productId, this.$db.products[this.productId + "-1"]);
                                this.$delete(this.$db.products, this.productId + "-1");
                            } else {
                                this.$delete(this.$db.products, this.productId);
                            }
                        } else
                            this.$delete(this.$db.products, this.productId + "-1");
                    }
                    // Delete all product options
                    else if (this.item.id === "none") {
                        this.$set(this.$db.products, this.productId, this.item);
                        this.$delete(this.$db.products, this.productId + "-1");
                    } else {
                        // Second option is being selected -> move 1st option to 2nd place and set current option as 1st
                        if (this.$db.products[this.productId] && this.$db.products[this.productId].id !== "none") {
                            this.$set(this.$db.products, this.productId + "-1", this.$db.products[this.productId]);
                            this.$set(this.$db.products, this.productId, this.item);
                        } else {
                            // Set current option as 1st
                            this.$set(this.$db.products, this.productId, this.item);
                        }
                    }
                // Multiple product categories can be selected
                } else {
                    // Checkbox unchecked
                    if (!e.target.checked) {
                        this.$delete(this.$db.products, this.productId + "-" + this.item.subproduct);
                    }
                    // Set subproduct value
                    else if (this.item.id !== "none") {
                        this.$set(this.$db.products, this.productId + "-" + this.item.subproduct, this.item);
                        this.$delete(this.$db.products, this.productId);
                    } else {
                        // Remove all subproduct values
                        Object.keys(this.$db.products).forEach(item => {
                            if (item.substr(0, this.productId.length) === this.productId && item.substr(this.productId.length + 1) !== "fabrics")
                                this.$delete(this.$db.products, item);
                        });

                        this.$set(this.$db.products, this.productId, this.item);
                    }
                }

				// Emit global event
				EventBus.$emit("product-selected-" + this.productId, this.item);
			},
		},
		computed: {
			isSelected() {
			    // Check if this item is selected as 1st product option
			    if (this.multiple) {
			        let selectedProduct2 = this.$db.products[this.productId + "-1"];

			        if (typeof selectedProduct2 !== "undefined" && selectedProduct2.id === this.item.id)
			            return true;
                }

				let selectedProduct = this.$db.products[this.productId];

			    // Subproduct
				if (this.item.subproduct)
				    selectedProduct = this.$db.products[this.productId + "-" + this.item.subproduct];

				// Some value is selected for this product
				if (typeof selectedProduct !== "undefined")
					// Check if this option is the selected one
					return selectedProduct.id === this.item.id;

				// No value is selected for this product -> check just if it is default
				return this.item.default;
			},

            canSelectMultiple() {
			    return this.multiple || typeof this.item.subproduct !== "undefined";
            }
		},
		created() {
			// Product option not selected yet -> pick the default one
			if (this.item.default && typeof this.$db.products[this.productId] === "undefined")
				this.saveOption();
		}
	}
</script>
